import React from "react";
import l from "components/util/l";

// The three ways to comment on a revision, each paired with a small mock of what the real
// interaction looks like. They are drawn instead of screenshotted so they keep matching the
// product when its styles change.
const STEPS = [
  {
    icon: "fas fa-expand-arrows-alt",
    iconColor: "#2065a5",
    iconBg: "linear-gradient(135deg, #e8f1fb 0%, #c8dcf5 100%)",
    titleKey: "1. Selecciona un área en las pantallas para comentar%PA525",
    mockup: (
      <div
        className="rounded overflow-hidden border"
        style={{ background: "#f4f7fb", height: "110px" }}
      >
        <div className="w-100 h-100 d-flex align-items-center justify-content-center">
          <i className="fas fa-image fa-3x" style={{ color: "#c5d5e8" }}></i>
        </div>
        <div
          className="position-absolute"
          style={{
            top: "50%", left: "50%",
            transform: "translate(-50%, -50%)",
            width: "100px", height: "52px",
            border: "2px dashed #2065a5",
            borderRadius: "3px",
            background: "rgba(32, 101, 165, 0.09)",
          }}
        />
        <div
          className="position-absolute rounded px-2 py-1"
          style={{
            top: "63%", left: "60%",
            transform: "translate(-42%, 12px)",
            background: "#fff", border: "1px solid #d0e5f9",
            fontSize: "0.7rem", color: "#333", whiteSpace: "nowrap",
            boxShadow: "0 2px 6px rgba(0,0,0,0.10)",
          }}
        >
          <i className="fas fa-pen mr-1" style={{ color: "#2065a5" }}></i>
          {l("Escribe tu comentario...%BR057")}
        </div>
      </div>
    ),
  },
  {
    icon: "fas fa-i-cursor",
    iconColor: "#1a7f5a",
    iconBg: "linear-gradient(135deg, #e0f5ed 0%, #b8e8d6 100%)",
    titleKey: "2. Remarca un texto para agregar comentarios%PA527",
    mockup: (
      <div
        className="rounded border p-3"
        style={{ background: "#f8fffe", fontSize: "0.8rem", lineHeight: 1.6 }}
      >
        <p className="mb-1 text-muted" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600 }}>
          {l("Sección de texto%BR058")}
        </p>
        <p className="mb-0 text-dark">
          {l("El sistema automatiza el proceso de%BR059")}{" "}
          <span
            className="px-1 rounded"
            style={{ background: "#b8e8d6", borderBottom: "2px solid #1a7f5a", cursor: "text" }}
          >
            {l("gestión de clientes%BR060")}
          </span>{" "}
          {l("en tiempo real.%BR061")}
        </p>
        <div
          className="mt-2 px-2 py-1 rounded d-inline-flex align-items-center"
          style={{ background: "#fff", border: "1px solid #b8e8d6", fontSize: "0.7rem", color: "#1a7f5a" }}
        >
          <i className="fas fa-comment-dots mr-1"></i>
          ¿Esto incluye CRM?
        </div>
      </div>
    ),
  },
  {
    icon: "fas fa-comments",
    iconColor: "#7c4dbb",
    iconBg: "linear-gradient(135deg, #f0eafb 0%, #ddd0f5 100%)",
    titleKey: "3. Revisa tus comentarios en el panel derecho%PA529",
    mockup: (
      <div
        className="rounded d-flex flex-column"
        style={{ background: "#faf8ff", fontSize: "0.8rem", border: "1px solid #e8e0f5", padding: "8px", gap: "6px" }}
      >
        <div className="p-2 rounded" style={{ background: "#fff", border: "1px solid #e0d8f5" }}>
          <span style={{ fontSize: "0.65rem", background: "#ede0ff", color: "#7c4dbb", borderRadius: "4px", padding: "1px 5px", fontWeight: 600 }}>
            <i className="fas fa-image mr-1"></i>#1 · Pantalla
          </span>
          <p className="mb-0 text-dark mt-1" style={{ fontSize: "0.72rem" }}>Revisar este flujo</p>
        </div>
        <div className="p-2 rounded" style={{ background: "#fff", border: "1px solid #e0d8f5" }}>
          <span style={{ fontSize: "0.65rem", background: "#ede0ff", color: "#7c4dbb", borderRadius: "4px", padding: "1px 5px", fontWeight: 600 }}>
            <i className="fas fa-align-left mr-1"></i>#2 · Descripción
          </span>
          <p className="mb-0 text-dark mt-1" style={{ fontSize: "0.72rem" }}>¿Incluye integración?</p>
        </div>
        <button
          type="button"
          className="btn btn-sm w-100"
          style={{ background: "#7c4dbb", color: "#fff", borderRadius: "8px", fontSize: "0.7rem" }}
        >
          <i className="fas fa-plus mr-1"></i>
          {l("Agregar comentario%BR062")}
        </button>
      </div>
    ),
  }
];

export default STEPS;
